import { defineComponent as _defineComponent } from 'vue'
import { vModelRadio as _vModelRadio, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, createVNode as _createVNode, normalizeClass as _normalizeClass, unref as _unref, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = ["value", "name"]
const _hoisted_2 = ["value"]
const _hoisted_3 = ["checked"]
const _hoisted_4 = {
  key: 5,
  class: "checkmark-toggle"
}
const _hoisted_5 = {
  key: 1,
  class: "checkbox-group relative flex items-center cursor-pointer"
}
const _hoisted_6 = ["value", "name"]
const _hoisted_7 = ["value"]
const _hoisted_8 = ["checked"]

import IconCheck from '@/components/icons/IconCheck.vue';
import { DynamicKeyValue } from '@/utils/types';
import { computed } from '@vue/reactivity';
import { ref, onMounted, watch } from 'vue';

interface CheckmarkColorVar {
  '--border-color'?: string,
  '--bg-color'?: string,
  '--stroke-color'?: string,
  '--checked-border-color'?: string,
  '--checked-bg-color'?: string,
  '--checked-stroke-color'?: string,
  '--hover-bg-color'?: string,
  '--hover-border-color'?: string,
  '--hover-checked-border-color'?: string,
  '--hover-checked-bg-color'?: string,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseCheckbox',
  props: {
    modelValue: { type: [String, Boolean, Number, Array], default: false },
    selectValue: { type: [String, Number, Boolean], default: '' },
    label: { default: '' },
    labelClass: { default: '' },
    isMultiple: { type: Boolean, default: false },
    isRadio: { type: Boolean, default: false },
    reverse: { type: Boolean, default: false },
    dark: { type: Boolean, default: false },
    name: { default: '' },
    disabled: { type: Boolean, default: false },
    toggle: { type: Boolean, default: false },
    rounded: { type: Boolean, default: false },
    alignItems: { default: '' },
    customLabel: { type: Boolean, default: false },
    checkmarkClass: { default: '' },
    customCheckmarkVar: { default: undefined },
    radioCheck: { type: Boolean, default: false },
    notLabelWrap: { type: Boolean, default: false },
    notLabelWrapClass: { default: '' }
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit }) {

const props = __props;





const currentSelectRadio = ref<string | boolean | [] | number>('');
const currentSelectCheckboxMultiple = ref<[]>([]);
const currentSelectCheckboxBoolean = ref<boolean>(false);

onMounted(() => {
  if (props.isRadio) {
    currentSelectRadio.value = props.modelValue;
  } else {
    if (Array.isArray(props.modelValue)) {
      currentSelectCheckboxMultiple.value = props.modelValue;
    } else if (typeof props.modelValue === 'boolean') {
      currentSelectCheckboxBoolean.value = props.modelValue;
    }
  }
});

const customCheckmarkStyle: DynamicKeyValue | string = computed(() => {
  if (!props.customCheckmarkVar) {
    return '';
  }
  return {
    ...props.customCheckmarkVar,
  };
});

// Watchers
watch(() => props.modelValue, (newValue) => {
  if (props.isRadio) {
    currentSelectRadio.value = newValue;
  } else {
    if (Array.isArray(newValue)) {
      currentSelectCheckboxMultiple.value = newValue;
    } else if (typeof newValue === 'boolean') {
      currentSelectCheckboxBoolean.value = newValue;
    }
  }
});

function onSelectRadio(e: Event) {
  const element = e.target as HTMLInputElement;
  currentSelectRadio.value = element.value;
  emit('update:modelValue', element.value);
}

function onSelectCheckboxMultiple(e: Event) {
  const element = e.target as HTMLInputElement;
  emit('update:modelValue', element.value);
}
function onSelectCheckboxBoolean(e: Event) {
  const element = e.target as HTMLInputElement;
  emit('update:modelValue', element.checked);
}

return (_ctx: any,_cache: any) => {
  return (!_ctx.notLabelWrap)
    ? (_openBlock(), _createElementBlock("label", {
        key: 0,
        class: _normalizeClass([
      'checkbox-group relative flex items-center cursor-pointer',
      _ctx.alignItems,
      _ctx.reverse && 'flex-row-reverse',
      _ctx.disabled ? 'opacity-50 pointer-events-none' : null
    ])
      }, [
        (_ctx.isRadio)
          ? _withDirectives((_openBlock(), _createElementBlock("input", {
              key: 0,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((currentSelectRadio).value = $event)),
              value: _ctx.selectValue,
              name: _ctx.name,
              class: "hidden",
              type: "radio",
              onChange: onSelectRadio
            }, null, 40, _hoisted_1)), [
              [_vModelRadio, currentSelectRadio.value]
            ])
          : (_ctx.isMultiple)
            ? _withDirectives((_openBlock(), _createElementBlock("input", {
                key: 1,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((currentSelectCheckboxMultiple).value = $event)),
                value: _ctx.selectValue,
                class: "hidden",
                type: "checkbox",
                onChange: onSelectCheckboxMultiple
              }, null, 40, _hoisted_2)), [
                [_vModelCheckbox, currentSelectCheckboxMultiple.value]
              ])
            : (_openBlock(), _createElementBlock("input", {
                key: 2,
                class: "hidden",
                type: "checkbox",
                checked: currentSelectCheckboxBoolean.value,
                onChange: onSelectCheckboxBoolean
              }, null, 40, _hoisted_3)),
        (_ctx.radioCheck)
          ? (_openBlock(), _createElementBlock("span", {
              key: 3,
              class: _normalizeClass(['checkmark-radio-check-box', _ctx.rounded ? 'rounded' : null])
            }, [
              _createVNode(IconCheck, {
                class: "icon",
                size: 11
              })
            ], 2))
          : (_ctx.isRadio)
            ? (_openBlock(), _createElementBlock("span", {
                key: 4,
                class: _normalizeClass(['checkmark-radio-box', _ctx.rounded ? 'rounded' : null])
              }, null, 2))
            : (_ctx.toggle)
              ? (_openBlock(), _createElementBlock("span", _hoisted_4))
              : (_openBlock(), _createElementBlock("span", {
                  key: 6,
                  class: _normalizeClass(['checkmark-check-box', _ctx.rounded ? 'rounded' : null, _ctx.checkmarkClass]),
                  style: _normalizeStyle(_unref(customCheckmarkStyle))
                }, [
                  _createVNode(IconCheck, {
                    class: "icon",
                    size: 11
                  })
                ], 6)),
        (_ctx.label)
          ? (_openBlock(), _createElementBlock("p", {
              key: 7,
              class: _normalizeClass([
        _ctx.reverse ? 'mr-2' : 'ml-2',
        _ctx.labelClass
      ])
            }, _toDisplayString(_ctx.label), 3))
          : _createCommentVNode("", true),
        (_ctx.customLabel)
          ? _renderSlot(_ctx.$slots, "customLabel", { key: 8 })
          : _createCommentVNode("", true)
      ], 2))
    : (_openBlock(), _createElementBlock("div", _hoisted_5, [
        (_ctx.isRadio)
          ? _withDirectives((_openBlock(), _createElementBlock("input", {
              key: 0,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((currentSelectRadio).value = $event)),
              value: _ctx.selectValue,
              name: _ctx.name,
              class: "hidden",
              type: "radio",
              onChange: onSelectRadio
            }, null, 40, _hoisted_6)), [
              [_vModelRadio, currentSelectRadio.value]
            ])
          : (_ctx.isMultiple)
            ? _withDirectives((_openBlock(), _createElementBlock("input", {
                key: 1,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((currentSelectCheckboxMultiple).value = $event)),
                value: _ctx.selectValue,
                class: "hidden",
                type: "checkbox",
                onChange: onSelectCheckboxMultiple
              }, null, 40, _hoisted_7)), [
                [_vModelCheckbox, currentSelectCheckboxMultiple.value]
              ])
            : (_openBlock(), _createElementBlock("input", {
                key: 2,
                class: "hidden",
                type: "checkbox",
                checked: currentSelectCheckboxBoolean.value,
                onChange: onSelectCheckboxBoolean
              }, null, 40, _hoisted_8)),
        (_ctx.radioCheck)
          ? (_openBlock(), _createElementBlock("span", {
              key: 3,
              class: _normalizeClass(['checkmark-radio-check-box', _ctx.rounded ? 'rounded' : null, _ctx.notLabelWrapClass])
            }, [
              _createVNode(IconCheck, {
                class: "icon",
                size: 11
              })
            ], 2))
          : (_ctx.isRadio)
            ? (_openBlock(), _createElementBlock("span", {
                key: 4,
                class: _normalizeClass(['checkmark-radio-box', _ctx.rounded ? 'rounded' : null, _ctx.notLabelWrapClass])
              }, null, 2))
            : (_ctx.toggle)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 5,
                  class: _normalizeClass(['checkmark-toggle', _ctx.notLabelWrapClass])
                }, null, 2))
              : (_openBlock(), _createElementBlock("span", {
                  key: 6,
                  class: _normalizeClass(['checkmark-check-box', _ctx.rounded ? 'rounded' : null, _ctx.checkmarkClass, _ctx.notLabelWrapClass]),
                  style: _normalizeStyle(_unref(customCheckmarkStyle))
                }, [
                  _createVNode(IconCheck, {
                    class: "icon",
                    size: 11
                  })
                ], 6)),
        _renderSlot(_ctx.$slots, "notLabelWrap")
      ]))
}
}

})